import styled from "styled-components";

const ProdctListContainer = styled.section`
    margin: 30px 0 30px;
`

export default ProdctListContainer